import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';

@Component({
  selector: 'app-link-card',
  templateUrl: './link-card.component.html',
  styleUrls: ['./link-card.component.scss']
})
export class LinkCardComponent {
  @Input() label: string = '';
  @Input() link: string = '';
  @Input() mode: string = '';
  saveDialogRef!: any;

  constructor(private dialog: MatDialog) {}

  openLink() {
    window.open(this.link, '_blank');
  }

  copyLink() {
    navigator.clipboard.writeText(this.link).then(() => {
      this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
            data: {
              imgSuccess: true,
              message: 'تم نسخ الرابط',
              button: 'تم',
            },
          });
    });
  }
}
